import { render, staticRenderFns } from "./StockValidationModal.vue?vue&type=template&id=70d13c7c&scoped=true&lang=pug"
import script from "./StockValidationModal.vue?vue&type=script&lang=js"
export * from "./StockValidationModal.vue?vue&type=script&lang=js"
import style0 from "./StockValidationModal.vue?vue&type=style&index=0&id=70d13c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d13c7c",
  null
  
)

export default component.exports